import { render, staticRenderFns } from "./ConsultingItem.vue?vue&type=template&id=aa1a1504&scoped=true&"
import script from "./ConsultingItem.vue?vue&type=script&lang=js&"
export * from "./ConsultingItem.vue?vue&type=script&lang=js&"
import style0 from "@styles/other/home/homeHotwords.css?vue&type=style&index=0&id=aa1a1504&scoped=true&lang=css&"
import style1 from "./ConsultingItem.vue?vue&type=style&index=1&id=aa1a1504&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1a1504",
  null
  
)

export default component.exports